/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseSalePointDto } from '../../models/api-response-sale-point-dto';
import { SalePointDto } from '../../models/sale-point-dto';

export interface UpdateSalePoint$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  reference: string;
      body: SalePointDto
}

export function updateSalePoint(http: HttpClient, rootUrl: string, params: UpdateSalePoint$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseSalePointDto>> {
  const rb = new RequestBuilder(rootUrl, updateSalePoint.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('reference', params.reference, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseSalePointDto>;
    })
  );
}

updateSalePoint.PATH = '/v1/api/sale-points/{reference}';
